<div class="card performance-growth-wrap">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5>{{ 'Employee Performance Growth' | translate }}</h5>
    </div>
  </div>
  <div class="card-body pt-0">
    <span class="help-icon fas fa-info-circle"
        [ngbTooltip]="tooltip.text | translate"
        [placement]="tooltip.placement"
        container="body"></span>
    <div class="growth-wrapper">
      <div id="performanceGrowthChart">
        <apx-chart
          *ngIf="performanceGrowth"
          [series]="performanceGrowth.series"
          [chart]="performanceGrowth.chart"
          [grid]="performanceGrowth.grid"
          [colors]="performanceGrowth.colors"
          [plotOptions]="performanceGrowth.plotOptions"
          [stroke]="performanceGrowth.stroke"
          [xaxis]="performanceGrowth.xaxis"
          [yaxis]="performanceGrowth.yaxis"
        ></apx-chart>
      </div>
    </div>
  </div>
</div>
